
if (!window.neoCartDrawerPromoInitialized) {
  window.neoCartDrawerPromoInitialized = true;

  async function refreshNeoCartDrawer() {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(root + '?sections=cart-drawer');

    if (!response.ok) {
      throw new Error('Cart drawer refresh failed');
    }

    const sections = await response.json();
    const sectionHTML = sections['cart-drawer'];

    if (!sectionHTML) {
      throw new Error('Cart drawer section not found');
    }

    const html = new DOMParser().parseFromString(
      sectionHTML,
      'text/html'
    );

    const newDrawer = html.querySelector('.drawer__inner');
    const currentDrawer = document.querySelector(
      'cart-drawer .drawer__inner'
    );

    if (!newDrawer || !currentDrawer) {
      throw new Error('Cart drawer element not found');
    }

    currentDrawer.innerHTML = newDrawer.innerHTML;
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest(
      '.neo-cart-promo[data-neo-promo-context="drawer"] .neo-cart-promo__apply'
    );

    if (!button || button.disabled) return;

    const promo = button.closest('.neo-cart-promo');
    const input = promo?.querySelector('.neo-cart-promo__input');
    const code = input?.value.trim();

    if (!code) return;

    button.disabled = true;
    button.textContent = 'Applying...';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: code })
      });

      if (!response.ok) {
        throw new Error('Discount request failed');
      }

      const cart = await response.json();

      const applied = (cart.discount_codes || []).some(
        (discount) =>
          discount.code.toLowerCase() === code.toLowerCase() &&
          discount.applicable
      );

      if (!applied) {
        alert('This promo code cannot be applied.');
        return;
      }

      await refreshNeoCartDrawer();

    } catch (error) {
      console.error('Drawer promo apply error:', error);
      alert('Unable to apply the promo code. Please try again.');
    } finally {
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = 'Apply';
      }
    }
  });

  document.addEventListener('click', async function (event) {
    const button = event.target.closest(
      '.neo-cart-promo[data-neo-promo-context="drawer"] .neo-cart-promo__remove'
    );

    if (!button || button.disabled) return;

    button.disabled = true;
    button.textContent = 'Removing...';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const cartResponse = await fetch(root + 'cart.js');

      if (!cartResponse.ok) {
        throw new Error('Could not load cart');
      }

      const cart = await cartResponse.json();
      const codeToRemove = button.dataset.code.toLowerCase();

      const remainingCodes = (cart.discount_codes || [])
        .filter(
          (discount) =>
            discount.code.toLowerCase() !== codeToRemove
        )
        .map((discount) => discount.code);

      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: remainingCodes.join(',')
        })
      });

      if (!response.ok) {
        throw new Error('Could not remove discount code');
      }

      const updatedCart = await response.json();

      const stillApplied = (updatedCart.discount_codes || []).some(
        (discount) =>
          discount.code.toLowerCase() === codeToRemove
      );

      if (stillApplied) {
        throw new Error('Discount code was not removed');
      }

      await refreshNeoCartDrawer();

    } catch (error) {
      console.error('Drawer promo remove error:', error);
      alert('Unable to remove the promo code. Please try again.');
    } finally {
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = 'Remove';
      }
    }
  });
}
